import React from 'react';
import { useParams } from 'react-router-dom';
import PublicCatalogView from '../components/PublicCatalogView/PublicCatalogView';

const PublicCatalogWrapper = () => {
  const { catalogId, providerId } = useParams();
  
  return <PublicCatalogView catalogId={catalogId} providerId={providerId} />;
};

export default PublicCatalogWrapper;